import { StepProgress } from "components/StepProgress/StepProgress";
import { Tooltip } from "components/Tooltip/Tooltip";
import { ModalRunProgress } from "pages/gdt/modals/ModalRunProgress/ModalRunProgress";
import { DataTableStoreState } from "pages/gdt/store/DataTableProvider.types";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { colorsByRunStatus } from "types/ColorsByRunStatus";
import { RunStatus, RunStepStatus } from "types/constants";

export interface RunProgressProps {
  row: {
    id: string;
    run: NonNullable<
      Extract<
        DataTableStoreState["tables"][number],
        { kind: "workflow" }
      >["rows"][number]["run"]
    >;
  };
}

export const RunProgress = ({ row }: RunProgressProps) => {
  const run = row.run;
  const { openModal: _openModal, closeModal } = useModalContext();
  const color = colorsByRunStatus[run.status];

  const tooltipContent = (
    <>
      <span style={{ color }}>{RunStepStatus[run.status]}</span>
      <br />
      View run details
    </>
  );
  const openModal = () =>
    _openModal(<ModalRunProgress rowId={row.id} onClose={closeModal} />);
  if (run.status === RunStatus["COMPLETE"]) {
    return (
      <Tooltip content={tooltipContent}>
        <StepProgress
          style={{
            inlineSize: "24px",
          }}
          size="m"
          stepColors={[colorsByRunStatus[RunStatus["COMPLETE"]]]}
          onClick={openModal}
        />
      </Tooltip>
    );
  }
  if (run.status === RunStatus["FAILED"]) {
    return (
      <Tooltip content={tooltipContent}>
        <StepProgress
          style={{
            inlineSize: "24px",
          }}
          size="m"
          stepColors={[colorsByRunStatus[RunStatus["FAILED"]]]}
          onClick={openModal}
        />
      </Tooltip>
    );
  }
  return (
    <Tooltip content={tooltipContent}>
      <StepProgress
        size="m"
        style={{
          inlineSize: "24px",
        }}
        stepColors={run.progress.nodes.map((n) => colorsByRunStatus[n.status])}
        onClick={openModal}
      />
    </Tooltip>
  );
};
